import { render, staticRenderFns } from "./sponsor_joiner_admin.vue?vue&type=template&id=20f473fc&scoped=true&"
import script from "./sponsor_joiner_admin.vue?vue&type=script&lang=js&"
export * from "./sponsor_joiner_admin.vue?vue&type=script&lang=js&"
import style0 from "./sponsor_joiner_admin.vue?vue&type=style&index=0&id=20f473fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f473fc",
  null
  
)

export default component.exports